module.exports = __webpack_public_path__ + "static/media/custom_bullet_objective.3651c3f7.svg";